import fetch from 'cross-fetch'
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'

export const apolloClient = new ApolloClient({
  link: new HttpLink({
    uri: `${process.env.API_GATEWAY}/b2b-portal-bff/graphql`,
    fetch,
  }),
  cache: new InMemoryCache(),
})
